// extracted by mini-css-extract-plugin
export var container = "y1zzK";
export var content = "tw_4j";
export var scrollableContent = "zRnKH";